import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.MuiPaper-root': {
      backgroundImage: 'unset',
    },
    [theme.breakpoints.down('sm')]: {
      '.MuiPaper-root': {
        borderRadius: [0],
      },
    },
    '.MuiButton-root': {
      borderRadius: '20px',
    },
  },
}));

export default useStyles;
